import {
  SESSIONS_DETAIL_ORDER_VINCULATION,
  SESSIONS_DETAIL_ORDER_VINCULATION_ERROR,
} from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const orderVinculationSessionsDetailAction =
  (transactions_id, sessions_id) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
      const response = await axiosTokenInstance.get(
        `/api/reports/linked-up/${transactions_id}/sessions/${sessions_id}`,
      );
      const { data, status } = response || {};
      dispatch({
        type: SESSIONS_DETAIL_ORDER_VINCULATION,
        response: data || {},
        status: status || {},
        method: 'get',
      });
    } catch (e) {
      dispatch({
        type: SESSIONS_DETAIL_ORDER_VINCULATION_ERROR,
        response: e?.response?.data || e || {},
        status: e?.response?.status || null,
        method: 'get',
      });
    }
  };
